import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import NoRecord from "./other/NoRecord";
import { pageRoutes } from "../routes/pageRoutes";
import PaginationDropdown from "./PaginationDropdown";
import ReactPagination from "./reactPagination";
import { checkStatus, pipViewDate } from "../utils/pip";
import { setSelectedUser } from "../redux/reducers/userReducer";

const UserTable = ({ data, filterCriteria }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const { userList, selectedUser } = useSelector((state) => state.userReducer);
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUserPerPages] = useState(5);

  const paginatedUser = data?.slice(
    currentPage * usersPerPage,
    (currentPage + 1) * usersPerPage
  );

  const formattedLookingFor = (lookingFor) => {
    if (Array.isArray(lookingFor)) {
      return lookingFor.join(", ");
    }
    // If it's a string, ensure proper formatting (split and join again)
    return lookingFor
      ? lookingFor
        .split(",")
        .map((part) => part.trim())
        .join(", ")
      : "";
  };

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  useEffect(() => {
    if (!selectedUser && userList.length > 0) {
      dispatch(setSelectedUser(userList[0]));
    }
  }, [dispatch, userList, selectedUser]);

  function tableBody() {
    return paginatedUser?.map((item, index) => {
      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>
            <div class="d-flex align-items-center gap-2">
              <img
                src={
                  item?.images[0] == "No image"
                    ? "./user_profile.png"
                    : item?.images[0] ?? "./user_profile.png"
                }
                alt=""
                class="ct_img_36"
              />
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center gap-2 ">
              <div>
                <h5 class="ct_fs_14 ct_fw_700 mb-1">{item?.name ?? ""}</h5>
                <p class="mb-0 ct_fs_14 ct_fw_500">
                  <i class="bi bi-geo-alt me-2"></i>
                  {item?.city ?? ""}
                  {item?.city && item?.country && ","} {item?.country ?? ""}
                </p>
              </div>
            </div>
          </td>
          <td>
            <div className="">
              <p class="mb-1 ct_fw_600 ct_fs_16">{item?.gender ?? ""}</p>
              <p class="mb-0 ct_fw_600 ct_fs_16 ct_white_space_3_dot_12">
                {formattedLookingFor(item?.looking_for) ?? ""}
              </p>
            </div>
          </td>
          <td>
            <div className="">
              <p class="mb-0 ct_fw_600 ct_fs_16">{item?.age ?? 0} Years</p>
            </div>
          </td>
          <td>
            <div className="">
              <p class="mb-0 ct_fw_600 ct_fs_16">{item?.account_type ?? ''}</p>
            </div>
          </td>
          <td>
            <div className="">
              <p class="mb-0 ct_fw_600 ct_fs_16">
                <span>{pipViewDate(item?.created_at)}</span>
              </p>
            </div>
          </td>
          <td>
            <div className="">
              <p class="mb-0 ct_fw_600 ct_fs_16">{item?.report_count ?? 0}</p>
            </div>
          </td>
          <td>
            <div className="">
              <p class="mb-0 ct_fw_600 ct_fs_16">{item?.is_verified == 0 ? 'No Action' : item?.is_verified == 1 ? 'Accepted' : item?.is_verified == 2 ? 'Pending' : item?.is_verified == 2 ? 'Rejected' : ''}</p>
            </div>
          </td>
          <td>
            <ul class="d-flex align-items-center gap-3">
              {item?.facebook_link && (
                <li>
                  <a
                    href={`https://www.facebook.com/${encodeURIComponent(
                      item?.facebook_link
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-facebook ct_fs_20 text-dark"></i>
                  </a>
                </li>
              )}
              {item?.twitter_link && (
                <li>
                  <a
                    href={`https://www.twitter.com/${encodeURIComponent(
                      item?.twitter_link
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-twitter ct_fs_20 text-dark"></i>
                  </a>
                </li>
              )}
              {item?.instagram_link && (
                <li>
                  <a
                    href={`https://www.instagram.com/${encodeURIComponent(
                      item?.instagram_link
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa-brands fa-instagram ct_fs_20 text-dark"></i>
                  </a>
                </li>
              )}
            </ul>
          </td>
          <td class="text-end">
            <div className="">
              <p
                class={`mb-0 ct_fw_600 ct_fs_16 ct_fw_600 ${checkStatus(item?.is_blocked)
                  ? "ct_red_text"
                  : "ct_green_text"
                  }`}
              >
                {checkStatus(item?.is_blocked) ? "Blocked" : "Active"}
              </p>
            </div>
          </td>
          <td class="text-start">
            <div>
              <div className="d-flex align-items-center gap-4">
                <a
                  className=" ct_view_grey_btn"
                  onClick={() =>
                    navigate(pageRoutes?.userDescription, {
                      state: { selectedData: item },
                    })
                  }
                >
                  {" "}
                  <i class="fa-solid fa-eye ct_pointer_curser"></i>
                </a>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }

  return (
    <>
      <div class="table-responsive">
        {paginatedUser && paginatedUser?.length != 0 ? (
          <table className="table ct_custom_table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>User Image</th>
                <th>Name & Location</th>
                <th>Gender & Looking For</th>
                <th> Age</th>
                <th>Plan Type</th>
                <th>Join Date</th>
                <th>No. of times Reported</th>
                <th>Facial verification</th>
                <th>Social Account</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {pathname == pageRoutes?.newDashBoard
                ? tableBody()?.slice(0, 5)
                : tableBody()}
            </tbody>
          </table>
        ) : filterCriteria?.filterCriteria?.city ||
          filterCriteria?.filterCriteria?.country ||
          filterCriteria?.filterCriteria?.gender ||
          filterCriteria?.filterCriteria?.searchQuery ||
          filterCriteria?.filterCriteria?.status ? (
          <h3 className="text-center mt-4">
            There are no results with this search.
          </h3>
        ) : (
          <NoRecord />
        )}
      </div>
      {pathname != pageRoutes?.newDashBoard && paginatedUser?.length != 0 && (
        <>
          <div className="d-flex justify-content-between align-items-center mt-4">
            <div>
              <PaginationDropdown
                onChange={(val) => {
                  setUserPerPages(val);
                  setCurrentPage(0);
                }}
              />
            </div>
            <div>
              <ReactPagination
                pageCount={Math.ceil(data?.length / usersPerPage)}
                onPageChange={handlePageClick}
              />
            </div>
          </div>
        </>
      )}
      {/* User Image Preview Modal S */}
    </>
  );
};

export default UserTable;
